import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class ImageCtaCarousel extends Component {
	public readonly sliderEl: JQuery;
	public slider: JQuery | null = null;
	public sliderContainer: JQuery;
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		this.sliderEl = $(_element);
		this.sliderContainer = this.sliderEl.find("[data-element='slider']");
		this.initSlider();
		this.toggleButtonState();
	}

	initSlider(): void {
		const sliderOptions: JQuerySlickOptions = {
			accessibility: false,
			arrows: false,
			centerMode: false,
			cssEase: "linear",
			dots: false,
			draggable: false,
			infinite: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 1
					}
				}
			],
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 500,
			useTransform: false,
			variableWidth: true
		};

		this.sliderContainer = this.sliderContainer.slick(sliderOptions);

		$(this.sliderEl)
			.find("[data-next-arrow]")
			.on("click", () => {
				this.sliderContainer.slick("slickNext");
			});

		$(this.sliderEl)
			.find("[data-prev-arrow]")
			.on("click", () => {
				this.sliderContainer.slick("slickPrev");
			});
	}

	toggleButtonState(): void {
		const prevArrow = $(this.sliderEl).find("[data-prev-arrow]");
		const nextArrow = $(this.sliderEl).find("[data-next-arrow]");
		const firstSlide = $(this.sliderEl).find("[data-slick-index=0]");
		const lastSlide = $(this.sliderEl).find(".slick-slide:last");
		$(this.sliderEl)
			.find("[data-prev-arrow]")
			.on("click", () => {
				if (firstSlide.hasClass("slick-current")) {
					prevArrow.prop("disabled", true);
				}
				if (!lastSlide.hasClass("slick-current")) {
					nextArrow.prop("disabled", false);
				}
			});

		$(this.sliderEl)
			.find("[data-next-arrow]")
			.on("click", () => {
				prevArrow.prop("disabled", false);
			});
	}

	get isMobileView(): boolean {
		const tabletMinWidth = 767;

		return window.innerWidth < tabletMinWidth;
	}
}

ComponentFactory.registerComponent("imageCtaCarousel", ImageCtaCarousel);
